/**
 * @generated SignedSource<<02e61598a9c3b7388c4b6a029d39953a>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraIssueTypeIcon_Platform$data = {
  readonly avatar: {
    readonly small: string | null;
  } | null;
  readonly name: string;
  readonly " $fragmentType": "JiraIssueTypeIcon_Platform";
};
export type JiraIssueTypeIcon_Platform$key = {
  readonly " $data"?: JiraIssueTypeIcon_Platform$data;
  readonly " $fragmentSpreads": FragmentRefs<"JiraIssueTypeIcon_Platform">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "JiraIssueTypeIcon_Platform",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "concreteType": "JiraAvatar",
      "kind": "LinkedField",
      "name": "avatar",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "small"
        }
      ]
    }
  ],
  "type": "JiraIssueType"
};

(node as any).hash = "6f9309d38428a5c37de5c49fcc3fac28";

export default node;
